<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content d-flex flex-row" v-menu-permission="'list'">
      <DrawerHandler is-left class="col-lg-3 float-lg-left overflow-auto" style="height:750px" to-invisible>
        <!--EmFilterTree-->
        <em-filter-tree ref="emTree"
                        filterEnable checkEnable
                        :entity="modelName"
                        filterState="levelTreeFilter"
                        loadState="levelTreeNodes"
                        :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                        :node-appender="formatText"
                        textKeys="formattedText"
                        @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
      </DrawerHandler>
      <!--      :add-diy-dom="addDiyDom"-->
      <div class="float-lg-right col-lg-9">
        <div id="accordionFilter" class="content">
          <div class="card">
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                 data-parent="#accordionFilter">
              <div class="card-body">
                <form>
                  <em-filter :entity="modelName" ref="emListFilter"
                             @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div id="sithMesPrdProjectPlanDetailPpdResultTable" class="content">
          <div class="card my-1">
            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                 data-parent="#accordionResult">
              <div class="card-body">
                <em-table :entity="modelName"
                          ref="emTable" edit-disable
                          withCustomRowActions :inlineActionsDisabled="prop_inline!=='1'"
                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                  <template #left-header>

                    <em-button type="delete"
                               custom-label="批量删除"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="deleteBatch()"
                               :busy="onBachDelete"
                    >
                    </em-button>
                    <em-button type="check"
                               custom-label="启用"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               custom-icon="fa fa-fw fa-lg fa-check"
                               @click="handleEnable(true)"
                               :busy="onEnable"
                    >
                    </em-button>
                    <!--                               :disabled="actionDisabled('select')"-->
                    <em-button type="check"
                               custom-label="禁用"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               custom-icon="fa fa-fw fa-lg fa-close"
                               @click="handleEnable(false)"
                               :busy="onDisable"
                    >
                    </em-button>
                    <em-button type="import"
                               :disabled="actionDisabled('select')"
                               custom-label="主计划排产" show-name
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               :busy="onMainScheduling"
                               @click="handleScheduling()"
                    >
                      <!--                             v-b-modal.modal-schedule>-->
                    </em-button>
                  </template>
                  <template #right-header>
                      <em-button type="downloadFile"
                               custom-label="导出project"
                               style="font-size: 14px;"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               custom-icon="fa-solid fa-cloud-arrow-down"
                               @click="generateMSProject()"
                               :busy="generatingMSProject"
                      >
                      </em-button>
                  </template>
                  <template #customRowActions="{row}">
                    <b-button-group>
                      <em-button type="showEntity"
                                 custom-label="前置依赖"
                                 :class="'btn btn-outline-primary btn-sm'"
                                 custom-icon="fa fa-fw fa-lg fa-link"
                                 @click="popPpdd(row)">
                      </em-button>
                      <em-button
                          v-if="$_emLevelTreeListMixin_getGrandParentId(row)"
                          type="gotoGrandParent"
                          v-bind:class="'btn btn-outline-primary btn-sm'"
                          @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">
                      </em-button>
                      <em-button type="gotoChild"
                                 v-bind:class="'btn btn-outline-primary btn-sm'"
                                 @click="$_emLevelTreeListMixin_gotoChild(row)">
                      </em-button>
                    </b-button-group>
                  </template>
                </em-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"/>
    <sub-entity-list ref="ppddEntityList" sub-entity="sithMesProProjectPlanDetailDepPpdd"
                     parent-field="ppddIdOriginPpd"></sub-entity-list>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-08-30 18:04:31

import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
import EmFilterTree from "@/components/em/EmFilterTree";
import EmFilter from "@/components/em/EmFilter";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import subEntityList from "@/components/em/EmModal/SubEntityList";
import commonViewsUtil from "@/utils/commonViewsUtil";
import strUtil from "@/utils/strUtil"
import emApiMixin from "@/mixin/em/common/api";
import AttachmentMixin from "../../../mixin/em/common/stuffs/attachment/attachmentMixin";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "sithMesPrdProjectPlanDetailPpdLevelTreeListView",
    mixins: [emLevelTreeListMixin, emApiMixin, AttachmentMixin, emCommonUtilMixin],
    components: {DrawerHandler, EmFilter, EmFilterTree, subEntityList},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onMainScheduling: false,
            onBachDelete: false,
            onEnable: false,
            onDisable: false,
            generatingMSProject: false,
            schedulingForm: {
                ppdIds: '',
                schedulingStrategy: 2,  //尽早生产
                reSchedule: true, //强制重新排产
                beginTime: null,
                endTime: null,
                planType: 1,  //1主计划，2项目计划
            }
        }
    },
    computed: {
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            // return this.$refs.emTable.checkedItems.join(",")
            return this.$store.state[this.modelName]["checkedItems"].join(",")
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            // return this.$refs.emTable.checkedItems
            return this.$store.state[this.modelName]["checkedItems"]
        }
    },
  methods: {
    appendIcon2UserNodes(roleUserTreeNode) {
      let userPrefix = "user_"
      let deptPrefix = "dept_"
      if (roleUserTreeNode.id.startsWith(userPrefix)) {
        return Object.assign({iconSkin: "iconUser"}, roleUserTreeNode)
      } else if (roleUserTreeNode.id.startsWith(deptPrefix)) {
        if (!roleUserTreeNode.isParent)
          return Object.assign({iconSkin: "iconBuilding"}, roleUserTreeNode)
        else
          return Object.assign({iconSkin: "pIconBuilding"}, roleUserTreeNode)
      }
    },
    handleEnable(enable = true) {
      let checkedNodes = this.$refs.emTree.getCheckedNodes();
      let tempList = []
      for (let item of checkedNodes) {
        tempList.push(item.id);
      }
      if (tempList.length === 0) {
        this.$message.warning("没有选择任何有效项目计划详情");
        return;
      }

      enable ? this.onEnable = true : this.onDisable = true
      let url = `${this.entityBaseUrl}${enable ? 'enable' : 'disable'}?ids=${tempList.join(',')}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "操作成功")
            this.$refs.emListFilter.doQuery()
          }).finally(t => enable ? this.onEnable = false : this.onDisable = false)
    },
    actionDisabled(type) {
      if (this.checkedItems) {
        // 删除按钮在一条记录都没选的时候禁用
        if (type === "select") {
            // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
            return this.checkedItems && this.checkedItems.length === 0;
        }
        // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
        else if (type === "selectOne") {
            // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
            return this.checkedItems && this.checkedItems.length !== 1;
        }
      } else return false
    },
      popPpdd(row) {
          this.$refs.ppddEntityList.showModal(row.id)
      },
      generateMSProject() {
          this.generatingMSProject = true
          const filter = this.$store.state[this.modelName].filter;
          filter.ppdEnableFilter = true
          this.$_emApiMixin_post(`${this.entityBaseUrl}/generateMSProject`, filter)
              .then(() => {
                  this.$message.success("报告生成中，请留意小铃铛信息");
              }).catch(() => {
              this.$message.error('生成失败');
          }).finally(() => {
              this.generatingMSProject = false
          });
      },
      /**
       * 从项目计划详情跳转到主计划排产，这样可以更方便的筛选出想要调整的计划
       */
      handleScheduling() {
          this.onMainScheduling = true
          //给选中记录id赋值
          this.schedulingForm.ppdIds = this.selectIds
          //调用api
          this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi('sithMesPrdProjectPlanPrp')}/schedulingFromPpd`, this.schedulingForm)
              .then(response => {
                  //跳转到排产调整页面
                  this.$router.push({
                      name: 'sithMesPrdProjectPlanAdjust'
                      , params: {scheduledResult: response.data, pageType: "edit_b"}
                  })
              }).finally(result => this.onMainScheduling = false)
      },
      deleteBatch() {
          this.onBachDelete = true
          let checkedNodes = this.$refs.emTree.getCheckedNodes();
          let tempList = []
          for (let item of checkedNodes) {
              tempList.push(item.id);
          }
          if (tempList.length === 0) {
              this.$message.warning("没有选择任何有效项目计划详情");
              return;
          }
          let url = `${this.entityBaseUrl}batchDeleteWithSub?ids=${tempList.join(",")}`
          this.$_emApiMixin_delete(url, {})
              .then(response => {
                  commonViewsUtil.showSuccess(this, "批量删除成功")
                  this.$refs.emListFilter.doQuery()
              }).finally(t => this.onBachDelete = false)

      },
      formatText(nodeDate) {
          let formattedText = `${strUtil.getLast(nodeDate.ppdActivityId, '.')}:${nodeDate.ppdChineseDescription}`
          // let formattedText = `${strUtil.getLast(nodeDate.ppdActivityId, '.')}:${nodeDate.ppdChineseDescription}【${strUtil.datetimeStrToDateStr(nodeDate.ppdOmForecastStartTime)}
          // - ${strUtil.datetimeStrToDateStr(nodeDate.ppdOmForecastEndTime)}】
          // ${nodeDate.ppdDuration}天`
          // console.log("nodeDate is:",nodeDate,"ppdEnable is: ",nodeDate.ppdEnable)
          if (!nodeDate.ppdEnable) {
              return Object.assign({iconSkin: "minus1", formattedText}, nodeDate)
          } else
              return Object.assign({formattedText}, nodeDate)
      },
      // addDiyDom(treeId, treeNode) {
      //   var aObj = $("#" + treeNode.tId + "_a");
      //   if ($("#diyBtn_" + treeNode.id).length > 0) return;
      //   // var editStr = "<span id='diyBtn_space_" +treeNode.id+ "' > </span>"
      //   //     + "<button type='button' class='diyBtn1' id='diyBtn_" + treeNode.id
      //   //     + "' title='"+treeNode.name+"' onfocus='this.blur();'></button>";
      //   // var editStr = "<i class='el-icon-edit'></i>"
      //   var editStr = "<progress value='70' max='100' style='width:30px'></progress> 70%"
      //   aObj.append(editStr);
      //   // var btn = $("#diyBtn_"+treeNode.id);
      //   // if (btn) btn.bind("click", function(){alert("diy Button for " + treeNode.name);});
      // }
  },
  created() {
    this.$_emCommonListMixin_needToRefresh = false
  }
}
</script>